var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#D8D7CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 17.4375C25.3107 17.4375 25.5625 17.6893 25.5625 18V32C25.5625 32.3107 25.3107 32.5625 25 32.5625C24.6893 32.5625 24.4375 32.3107 24.4375 32V18C24.4375 17.6893 24.6893 17.4375 25 17.4375Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4375 25C17.4375 24.6893 17.6893 24.4375 18 24.4375H32C32.3107 24.4375 32.5625 24.6893 32.5625 25C32.5625 25.3107 32.3107 25.5625 32 25.5625H18C17.6893 25.5625 17.4375 25.3107 17.4375 25Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/imagePlus.9116e5a5e7906b61e48a7c389602facf.svg";
export { ForwardRef as ReactComponent };